import { createListenerMiddleware } from "@reduxjs/toolkit";
import { RootState } from "src/features/gifts/imports/types";
import { registerGift, removeCombo } from "./comboGiftsSlice";
import { getCombo } from "./selectors";

export const comboGiftsListenerMiddleware =
  createListenerMiddleware<RootState>();

comboGiftsListenerMiddleware.startListening({
  actionCreator: registerGift,
  effect: async (action, { delay, getState, dispatch }) => {
    const { giftId, accountId, duration } = action.payload;
    const durationInMs = duration * 1000;
    await delay(durationInMs);

    const state = getState();
    const combo = getCombo(state, giftId, accountId);
    const currentTime = Date.now();

    if (combo && currentTime - combo.startTime >= durationInMs) {
      dispatch(removeCombo({ giftId, accountId }));
    }
  },
});
